import { render, staticRenderFns } from "./AdminGeopoints.vue?vue&type=template&id=6402420d&"
import script from "./AdminGeopoints.vue?vue&type=script&lang=js&"
export * from "./AdminGeopoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports